import {TestIdProps} from 'shared/web';

import {InvoiceId} from '../utils/getInvoiceIdFromProps';

export type InvoicePaymentModalProps = TestIdProps &
  InvoiceId & {
    onAfterSubmit?: () => void;
  };
